import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUser } from '@features/auth/auth.slice';

interface AdminProtectedRouteProps {
    children: React.ReactNode;
    parentItem: 'member' | 'product';
}

export function AdminProtectedRoute({ children, parentItem }: AdminProtectedRouteProps) {
    const user = useSelector(getUser);

    const isAdmin = user?.role === 'admin';

    if (!isAdmin) {
        // Rediriger vers le tableau de bord approprié selon le contexte
        const dashboardUrl = parentItem === 'member' ? '/members-management' : '/products-management';

        return <Navigate to={dashboardUrl} replace />;
    }

    return <>{children}</>;
}
